import { Type_RefFuncKrpano } from '@components/Krpano/types';
import { useKrpano } from '@containers/Home/hook/useKrpano';
import { selectLanguageProject } from '@containers/Home/selectors';
import { Tooltip } from 'antd';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { LANGUAGES } from '@containers/Home/language';
import { SideToolbarWrapper } from './styled';

interface Props {
  krpanoRef?: Type_RefFuncKrpano;
}

const SideToolbar = memo(({ krpanoRef }: Props) => {
  const languageProject = useSelector(selectLanguageProject);

  const {
    // NOTE: info place
    isShowIconInfoPlace,
    onShowInfoPlace,
    // NOTE: info scene
    isShowIconInfoScene,
    onToggleInfoScene,
    // NOTE: floorplan
    isShowIconFloorplan,
    onToggleFloorplan,
    // NOTE: map
    isShowIconMap,
    onToggleMap,
  } = useKrpano({ krpanoRef });

  return isShowIconInfoPlace ||
    isShowIconInfoScene ||
    isShowIconFloorplan ||
    isShowIconMap ? (
    <SideToolbarWrapper>
      {isShowIconInfoPlace && (
        <Tooltip
          title={LANGUAGES[languageProject].controlbarInfoTour}
          placement="left"
        >
          <div className="itemSideBtn" onClick={onShowInfoPlace}>
            <i aria-hidden className="far fa-info" />
          </div>
        </Tooltip>
      )}

      {isShowIconInfoScene && (
        <Tooltip
          title={LANGUAGES[languageProject].controlbarInfoScene}
          placement="left"
        >
          <div
            className="itemSideBtn"
            onClick={onToggleInfoScene.bind(this, undefined)}
          >
            <i aria-hidden className="far fa-location-question" />
          </div>
        </Tooltip>
      )}

      {isShowIconFloorplan && (
        <Tooltip
          title={LANGUAGES[languageProject].controlbarFloorplan}
          placement="left"
        >
          <div
            className="itemSideBtn"
            onClick={onToggleFloorplan.bind(this, undefined)}
          >
            <i aria-hidden className="far fa-project-diagram" />
          </div>
        </Tooltip>
      )}

      {isShowIconMap && (
        <Tooltip
          title={LANGUAGES[languageProject].controlbarMap}
          placement="left"
        >
          <div
            className="itemSideBtn"
            onClick={onToggleMap.bind(this, undefined)}
          >
            <i aria-hidden className="far fa-map-marked-alt" />
          </div>
        </Tooltip>
      )}
    </SideToolbarWrapper>
  ) : (
    <div />
  );
});

export default SideToolbar;
